import { render } from "./MonthlyAchievements.vue?vue&type=template&id=071c9e92&scoped=true"
import script from "./MonthlyAchievements.vue?vue&type=script&lang=js"
export * from "./MonthlyAchievements.vue?vue&type=script&lang=js"

import "./MonthlyAchievements.vue?vue&type=style&index=0&id=071c9e92&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071c9e92"]])

export default __exports__